<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>工资管理</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/salary/salarySlipList' }">工资列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <el-input v-model.number="year" placeholder="年" class="input-size-100 input-margin-right" clearable></el-input>
              <el-input v-model.number="month" placeholder="月" class="input-size-100 input-margin-right" clearable></el-input>
              <el-input v-model="name" placeholder="姓名" class="input-size-100 input-margin-right" clearable></el-input>
              <el-input v-model="phone" placeholder="手机" class="input-size-150 input-margin-right" clearable></el-input>
              <el-input v-model="schoolNo" placeholder="员工号" class="input-size-100 input-margin-right" clearable></el-input>
<!--              <el-input v-model="account" placeholder="银行账号" class="input-size-150 input-margin-right" clearable></el-input>-->
              <el-input v-model="departmentName" placeholder="学校" v-if="userType == 'ORDINARY'" class="input-size-200 input-margin-right" clearable></el-input>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <el-button type="danger" icon="el-icon-minus" class="button-pull-right" style="margin-right: 20px" :disabled="!(dt.multipleSelection && dt.multipleSelection.length > 0)" @click="handleDelete();">删除</el-button>
              <el-button type="danger" icon="el-icon-minus" class="button-pull-right" :disabled="(dt.multipleSelection && dt.multipleSelection.length > 0)" @click="batchDeleteDialogVisible = true;">批量删除</el-button>
              <el-button type="" icon="el-icon-download" class="button-pull-right" style="margin-right: 20px" @click="exportDialogVisible = true;">导出</el-button>
              <el-button type="info" icon="el-icon-upload2" class="button-pull-right" style="margin-right: 20px" @click="excelResult = null; excelDialogVisible = true;">导入</el-button>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" @click="handleNoticeParamChange(); noticeDialogVisible = true;">公告</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              show-summary
              :summary-method="getSummaries"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange"
              :cell-style="{fontFamily: '宋体', fontSize: '16px'}"
            >
              <el-table-column
                type="selection"
                fixed
                width="50px">
              </el-table-column>
<!--              <el-table-column-->
<!--                property="id"-->
<!--                label="ID"-->
<!--                fixed-->
<!--                width="70px"-->
<!--                class-name="money">-->
<!--              </el-table-column>-->
              <el-table-column
                property="year"
                label="年"
                width="60px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="month"
                label="月"
                align="center"
                width="50px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="user.name"
                label="姓名"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="user.phone"
                label="手机"
                sortable="custom"
                width="120px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="user.schoolNo"
                label="员工号"
                sortable="custom"
                align="center"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
<!--              <el-table-column-->
<!--                property="user.account"-->
<!--                label="银行账号"-->
<!--                sortable="custom"-->
<!--                show-overflow-tooltip>-->
<!--              </el-table-column>-->
              <el-table-column
                property="payable"
                label="应发工资"
                min-width="100px"
                align="right"
                class-name="money"
                :formatter="moneyFormatter"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="deduct"
                label="应扣工资"
                min-width="100px"
                align="right"
                class-name="money"
                :formatter="moneyFormatter"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="actual"
                label="实发工资"
                min-width="100px"
                align="right"
                class-name="money"
                :formatter="moneyFormatter"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="departmentName"
                label="学校名称"
                v-if="userType == 'ORDINARY'"
                min-width="150px"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <!--<el-table-column-->
                <!--property="bannedTime"-->
                <!--:formatter="dateFormat"-->
                <!--label="禁言时间"-->
                <!--width="150px"-->
                <!--sortable="custom"-->
                <!--show-overflow-tooltip>-->
              <!--</el-table-column>-->
<!--              <el-table-column-->
<!--              property="parentPhone"-->
<!--              label="父账户手机"-->
<!--              width="100px"-->
<!--              sortable="custom"-->
<!--              show-overflow-tooltip>-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="type"-->
<!--                label="标签"-->
<!--                width="120">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-tag-->
<!--                    :type="scope.row.type === 'ORDINARY' ? 'primary' : 'success'"-->
<!--                    close-transition>{{scope.row.type=='ORDINARY'?'平台管理员':'学校管理员'}}-->
<!--                  </el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                property="updatedUserName"
                label="录入人"
                width="80px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="createdAt"
                label="创建时间"
                width="110px"
                class-name="money"
                :formatter="dateFormat"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="updatedAt"
                label="修改时间"
                width="110px"
                class-name="money"
                :formatter="dateFormat"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="confirmAt"
                label="确认时间"
                width="110px"
                class-name="money"
                :formatter="dateFormat"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="80px" class-name="money">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="handleUpdate(scope.$index, scope.row)">编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>

        <!-- 公告条弹出框 -->
        <el-dialog title="工资条公告" :visible.sync="noticeDialogVisible">
          <el-form :model="notice" ref="noticeForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="年" prop="noticeYear">
                  <el-input v-model.number="noticeYear"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月" prop="noticeMonth">
                  <el-input v-model.number="noticeMonth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="学校" prop="noticeDepartmentId" v-if="isAdminUser">
                  <el-select v-model="noticeDepartmentId" style="width: 100%" autocomplete filterable>
                    <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="公告内容" prop="noticeText"
                              :rules="[{required: true, message: '请输入', trigger: 'blur'}, {min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur'}]">
                  <el-input v-model="notice.noticeText" :disabled="!noticeCanInput" type="textarea" autosize :rows="4"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" :disabled="!noticeCanInput" @click="onNoticeSubmit('noticeForm')">确 定</el-button>
            <el-button @click="noticeDialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 公告条弹出框 END -->

        <!-- Excel 导入弹出框 -->
        <el-dialog title="Excel 导入" :visible.sync="excelDialogVisible">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="年" prop="noticeYear">
                  <el-input v-model.number="excelYear"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月" prop="noticeMonth">
                  <el-input v-model.number="excelMonth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="学校" class="is-required" prop="excelDepartmentId" v-if="isAdminUser">
                  <el-select v-model="excelDepartmentId" style="width: 100%" autocomplete filterable>
                    <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="Excel 文件" class="is-required" prop="excelFile">
                  <el-upload
                    class="upload-demo"
                    ref="upload"
                    accept=".xls,.xlsx"
                    :limit="1"
                    :action="this.httpBaseURL() + '/admin/salarySlip/importExcel?departmentId=' + this.excelDepartmentId + '&year=' + this.excelYear + '&month=' + this.excelMonth"
                    :headers="this.httpHead()"
                    :on-change="this.onImportExcelFileChange"
                    :on-success="handleImportExcelSuccess"
                    :auto-upload="false"
                  >
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <div slot="tip" class="el-upload__tip">请选择Excel文件</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="导入结果" prop="excelImportResult">
                  <div class="el-input" v-html="excelResult"
                       style="max-height: 250px; overflow:auto; padding: 1rem; border-radius: 4px; border: 1px solid #909399; line-height: 1.8rem"></div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="onImportExcelSubmit()" :disabled="!(excelYear && excelMonth && excelDepartmentId && excelFileSelected)">导 入</el-button>
            <el-button @click="excelDialogVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- Excel 导入弹出框 END -->

        <!-- 编辑弹窗 -->
        <el-dialog title="工资条" :visible.sync="updateDialogVisible">
          <el-form ref="form" :model="vo" label-width="200px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="vo.user.name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机" prop="phone">
                  <el-input v-model="vo.user.phone" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="学校" prop="departmentName">
                  <el-input v-model="vo.departmentName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工号" prop="schoolNo">
                  <el-input v-model="vo.user.schoolNo" disabled></el-input>
                </el-form-item>
              </el-col>
<!--              <el-col :span="24">-->
<!--                <el-form-item label="银行帐号" prop="account">-->
<!--                  <el-input v-model="vo.user.account" disabled></el-input>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="12">
                <el-form-item label="年" prop="year" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                  <el-input v-model="vo.year"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月" prop="month" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                  <el-input v-model.number="vo.month"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应发工资" prop="payable">
                  <el-input-number v-model.number="vo.payable" :precision="2" :controls="false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应扣工资" prop="deduct">
                  <el-input-number v-model.number="vo.deduct" :precision="2" :controls="false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实发工资" prop="actual">
                  <el-input-number v-model.number="vo.actual" :precision="2" :controls="false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-for="item in vo.itemList">
                <el-form-item :label="item.title" :prop="item.title">
                  <el-input-number v-model.number="item.amount" :precision="2" :controls="false"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="width: 100%; text-align: center">
              <el-button type="primary" @click="onSubmit('form')">确定</el-button>
              <el-button @click="updateDialogVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
        <!-- 编辑弹窗 END -->


        <!-- Excel 导出弹出框 -->
        <el-dialog title="Excel 导出" :visible.sync="exportDialogVisible">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="年" class="is-required" prop="exportYear">
                  <el-input v-model.number="exportYear"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月" class="is-required" prop="exportMonth">
                  <el-input v-model.number="exportMonth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="学校" class="is-required" prop="exportDepartmentId" v-if="isAdminUser">
                  <el-select v-model="exportDepartmentId" style="width: 100%" autocomplete filterable>
                    <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="onExportSubmit()" :disabled="!(exportYear && exportMonth && exportDepartmentId)">下 载</el-button>
            <el-button @click="exportDialogVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- Excel 导出弹出框 END -->


        <!-- 批量删除 弹出框 -->
        <el-dialog title="批量删除" :visible.sync="batchDeleteDialogVisible">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="年" class="is-required" prop="exportYear">
                  <el-input v-model.number="batchDeleteYear"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开始月份" class="is-required" prop="exportMonth">
                  <el-input v-model.number="batchDeleteFromMonth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结束月份" class="is-required" prop="exportMonth">
                  <el-input v-model.number="batchDeleteToMonth"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="学校" prop="exportDepartmentId" v-if="isAdminUser">
                  <el-select v-model="batchDeleteDepartmentId" style="width: 100%" autocomplete filterable clearable>
                    <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                  </el-select>
                  <el-marker>警告：不具体选择学校，将删除所有学校指定时间范围的数据，谨慎选择。</el-marker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="onBatchDeleteSubmit()" :disabled="!(batchDeleteYear && batchDeleteFromMonth && batchDeleteToMonth)">批量删除</el-button>
            <el-button @click="batchDeleteDialogVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- 批量删除 弹出框 END -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'SalarySlipList',
    data: function () {
      let userInfo = this.$store.state.userInfo;
      let that = this;
      return {
        userType: userInfo.type,
        departmentId: userInfo.departmentId,
        //  表格设置
        extnedsParms: {},
        dt: DataTable.getInstance(that, '/admin/salarySlip/findPage', null, null),
        name: '',
        phone: '',
        schoolNo: '',
        account: '',
        year: null,
        month: null,
        departmentName: '', // 学校名称 （平台管理员才使用）

        departmentList: [], // 学校列表

        // 公告弹窗
        noticeDialogVisible: false,
        noticeYear: that.$moment().year(),
        noticeMonth: that.$moment().month() + 1,
        noticeDepartmentId: userInfo.departmentId,
        notice: {noticeText: null},
        noticeCanInput: false,

        // 导入弹窗
        excelDialogVisible: false,
        excelYear: that.$moment().year(),
        excelMonth: that.$moment().month() + 1,
        excelDepartmentId: userInfo.departmentId,
        excelResult: null,
        excelFileSelected: false,

        // 编辑弹窗
        vo: {user: {}, itemList: null},
        updateDialogVisible: false,

        // 导出弹窗
        exportDialogVisible: false,
        exportYear: that.$moment().year(),
        exportMonth: that.$moment().month() + 1,
        exportDepartmentId: userInfo.departmentId,

        // 批量删除
        batchDeleteDialogVisible: false,
        batchDeleteYear: that.$moment().year() - 1,
        batchDeleteFromMonth: that.$moment().month(),
        batchDeleteToMonth: that.$moment().month() + 1,
        batchDeleteDepartmentId: null
      }
    },
    computed: {
      // 是否 平台管理员 在操作
      isAdminUser: function () {
        return this.userType === 'ORDINARY';
      }
    },
    watch: {
      noticeDepartmentId: function (o, n) {
        this.noticeCanInput = false;
        this.handleNoticeParamChange();
      },
      noticeYear: function (o, n) {
        this.noticeCanInput = false;
        this.handleNoticeParamChange();
      },
      noticeMonth: function (o, n) {
        this.noticeCanInput = false;
        this.handleNoticeParamChange();
      }
    },
    mounted: function () {
      // 清理旧的绑定属性
      this.dt.cleanBindFields();
      // 绑定过滤属性
      this.dt.bindStringField("user.name", "name");
      this.dt.bindStringField("user.phone", "phone");
      this.dt.bindStringField("user.schoolNo", "schoolNo");
      this.dt.bindStringField("user.account", "account");
      if (this.userType === 'ORDINARY') {
        this.dt.bindStringField("departmentName", "departmentName");
      }
      this.dt.bindNumberField("year", "year");
      this.dt.bindNumberField("month", "month");
      // 还原之前查询条件到Vue属性
      this.dt.bindFieldToVueProp();
      //  向后台查询数据
      this.dt.queryPageData()

      if (this.isAdminUser) {
        this.axios.get('/admin/department/findAll4Select')
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.departmentList = resp.data.data
            } else {
              this.$router.replace('/user/userList')
              this.$message({
                type: 'error',
                message: "获取部门列表失败"
              })
            }
          }).catch(resp => {
          this.$router.replace('/user/userList')
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      }
    },

    methods: {
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD");
      },
      fixedMoney: function (data) {
        return parseFloat(data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      },
      moneyFormatter: function (row, column) {
        let data = row[column.property];
        if (data === undefined || data === null) {
          return "";
        }
        return this.fixedMoney(data);
      },
      // 搜索
      search: function () {
        // 更新最新的查询条件
        this.dt.bindFieldToFilter();
        this.dt.queryPageData()
      },
      //  获取合计值
      getSummaries: function (param) {
        let s = [];
        if (this.dt && this.dt.sumData) {
          s[0] = '合计';
          let o = this.dt.sumData;
          s[6] = this.fixedMoney(o['sumPayable']);
          s[7] = this.fixedMoney(o['sumDeduct']);
          s[8] = this.fixedMoney(o['sumActual']);
        } else {
          s[6] = 0;
          s[7] = 0;
          s[8] = 0;
        }
        return s;
      },
      // 编辑记录
      handleEdit: function (index, row) {
        if (this.isAdminUser) { // 平台管理员
          this.$router.push({path: '/teacher/teacherModify', query: {id: row.id}});
        } else { //  学校管理员（限制学校id）
          let that = this;
          this.$router.push({path: '/teacher/teacherModify', query: {id: row.id, departmentId: that.departmentId}});
        }
      },
      // 公告条件改变
      handleNoticeParamChange: function () {
        if (this.noticeYear >= 2020 && this.noticeMonth > 0 && this.noticeDepartmentId > 0) {
          let that = this;
          this.axios.get('admin/salaryNotice/find', {params: {departmentId: that.noticeDepartmentId, year: that.noticeYear, month: that.noticeMonth}})
            .then(resp => { // 保存成功跳回列表页面
              if (resp.data && resp.data.code === 200) {
                if (resp.data.data) { // 已有公告
                  that.notice = resp.data.data;
                } else {
                  that.notice = {noticeText: null};
                }
                that.noticeCanInput = true;
              } else {
                this.$message({
                  type: 'error',
                  message: '处理失败!' + resp.data.message
                })
              }
            }).catch(resp => {
            this.$message({
              type: 'error',
              message: "请求服务器出错"
            })
          })
        }
      },
      // 工资条公告保存
      onNoticeSubmit: function (formName) {
        let vo = this.notice;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            vo.year = this.noticeYear;
            vo.month = this.noticeMonth;
            vo.departmentId = this.noticeDepartmentId;
            this.axios.post('admin/salaryNotice/save', vo)
              .then(resp => { // 保存成功跳回列表页面
                if (resp.data && resp.data.code === 200) {
                  this.$message({
                    type: 'success',
                    message: '处理成功!'
                  })
                  this.noticeDialogVisible = false;
                } else {
                  this.$message({
                    type: 'error',
                    message: '处理失败!' + resp.data.message
                  })
                }
              }).catch(resp => {
              this.$message({
                type: 'error',
                message: "请求服务器出错"
              })
            })
          } else {
            return false;
          }
        });
      },
      // Excel 选择文件改变
      onImportExcelFileChange: function (file, fileList) {
        this.excelFileSelected = (fileList && fileList.length === 1);
      },
      // Excel 上传提交
      onImportExcelSubmit: function () {
        this.loading = this.$loading({
          lock: true,
          text: '正在上传中....',
          spinner: 'el-icon-loading-new',
          background: 'rgba(0, 0, 0, 0.2)'
        });
        this.$refs.upload.submit();
      },
      // Excel 上传成功
      handleImportExcelSuccess: function (response, file, fileList) {
        this.$refs.upload.clearFiles();
        this.excelFileSelected = false;
        this.loading.close();
        if (response && response.code === 200) {
          this.excelResult = response.data;
          this.$message({
            type: 'success',
            message: '上传完成，请查看 导入结果'
          })
          this.search();
        } else {
          this.$message({
            type: 'error',
            message: response.message
          })
          this.excelResult = response.message;
        }
      },
      // 删除
      handleDelete: function () {
        let idList = [];
        this.dt.multipleSelection.forEach(f => idList.push(f.id));
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              setTimeout(() => {
                this.axios.post('/admin/salarySlip/deleteList', [], {params: {idList: idList.join()}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done();
                      this.dt.queryPageData();
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      });
                    } else {
                      done();
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      });
                    }
                  }).catch(resp => {
                  done();
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  });
                });
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300);
              }, 1000);
            } else {
              done();
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      //  编辑记录
      handleUpdate: function (idx, model) {
        let obj = {};
        Object.assign(obj, model);
        this.vo = obj;
        this.updateDialogVisible = true;
      },
      // 编辑提交
      onSubmit: function (formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.axios.post('admin/salarySlip/save', that.vo)
              .then(resp => { // 保存成功跳回列表页面
                if (resp.data && resp.data.code === 200) {
                  this.$message({
                    type: 'success',
                    message: '处理成功!'
                  })
                  this.updateDialogVisible = false;
                  this.search();
                } else {
                  this.$message({
                    type: 'error',
                    message: '处理失败!' + resp.data.message
                  })
                }
              }).catch(resp => {
              this.$message({
                type: 'error',
                message: "请求服务器出错"
              })
            })
          } else {
            return false;
          }
        });
      },
      // 导出提交
      onExportSubmit: function () {
        let that = this;
        this.loading = this.$loading({
          lock: true,
          text: '正在下载中....',
          spinner: 'el-icon-loading-new',
          background: 'rgba(0, 0, 0, 0.2)'
        });
        this.axios.post('/admin/salarySlip/exportExcel', [],
          {params: {departmentId: that.exportDepartmentId, year: that.exportYear, month: that.exportMonth}, responseType: 'blob'})
          .then(resp => { // 装载对象
            if (resp.data.type === "application/json") { // 后台处理过程异常
              const reader = new FileReader()
              reader.onload = function (event) {
                const message = JSON.parse(reader.result).message
                that.$message({
                  type: 'error',
                  message: "请求服务器出错 " + message
                })
              }
              reader.readAsText(resp.data)
            } else {
              let blob = new Blob([resp.data]);
              let fileName = "工资条" + resp.headers['content-disposition'].split('filename=').pop();
              if ('msSaveOrOpenBlob' in navigator) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }
          }).catch(resp => {
            // console.log(resp);
            this.$message({
              type: 'error',
              message: "请求服务器出错"
            })
          }).finally(() => {
            this.loading.close();
          });
      },
      // 批量删除
      onBatchDeleteSubmit: function () {
        let that = this;
        let msg = '此操作将永久删除指定时间范围的数据, 是否继续?';
        if (this.isAdminUser && !this.batchDeleteDepartmentId) {
          msg = '警告： 您没有选择学校， 此操作将永久删除 所有学校 指定时间范围的数据, 确定继续?'
        }
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              setTimeout(() => {
                this.axios.post('/admin/salarySlip/batchDeleteList', [],
                  {params: {
                                    year: that.batchDeleteYear,
                                    fromMonth: that.batchDeleteFromMonth,
                                    toMonth: that.batchDeleteToMonth,
                                    departmentId: that.batchDeleteDepartmentId
                  }})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done();
                      this.dt.queryPageData();
                      this.batchDeleteDialogVisible = false;
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      });
                    } else {
                      done();
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      });
                    }
                  }).catch(resp => {
                  done();
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  });
                });
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300);
              }, 1000);
            } else {
              done();
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  }
</script>
<style type="scss">
.money {
  font-family: '宋体';
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// SalarySlipList.vue?876ab94a